<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="shopAppraiseManageInfo.conditions.prodName" placeholder="商品名称" clearable />
        </el-col>
        <el-col :span="4">
          <el-input v-model="shopAppraiseManageInfo.conditions.appraiseUserName" placeholder="请输入用户" clearable />
        </el-col>
        <el-col :span="4">
          <el-select v-model="shopAppraiseManageInfo.conditions.appraiseScore" placeholder="请选择评分" style="width:100%" clearable>
            <el-option
              v-for="(item, index) in shopAppraiseManageInfo.appraiseScores"
              :key="index"
              :label="item.name"
              :value="item.statusCd"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="_queryOrdersMethod">查询</el-button>
          <el-button icon="el-icon-refresh" @click="_resetOrdersMethod">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>商品评论</span>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="_openAddDialog">新增评论</el-button>
      </div>
      <el-table :data="shopAppraiseManageInfo.appraises" border style="width: 100%">
        <el-table-column prop="objId" label="商品ID" align="center" width="160" show-overflow-tooltip />
        <el-table-column prop="prodName" label="商品名称" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="appraiseUserName" label="用户" align="center" width="120" />
        <el-table-column prop="appraiseScore" label="综合评分" align="center" width="90" />
        <el-table-column prop="logisticsScore" label="物流评分" align="center" width="90" />
        <el-table-column prop="serviceScore" label="服务评分" align="center" width="90" />
        <el-table-column prop="context" label="内容" align="center" min-width="160" show-overflow-tooltip />
        <el-table-column label="图片" align="center" width="100">
          <template slot-scope="scope">
            <template v-if="scope.row.imgPath">
              <el-image
                v-for="(img, idx) in getImgList(scope.row.imgPath)"
                :key="idx"
                :src="img"
                :preview-src-list="getImgList(scope.row.imgPath)"
                style="width: 40px; height: 40px; margin-right: 4px"
                fit="cover"
              />
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="评论时间" align="center" width="160" />
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="_openEditDialog(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" style="color: #F56C6C" @click="_openDeleteDialog(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" @close="_resetForm">
      <el-form ref="appraiseForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="商品ID" prop="objId">
          <el-input
            v-model="form.objId"
            placeholder="请输入商品ID"
            :disabled="isEdit"
            maxlength="30"
            clearable
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="用户名" prop="appraiseUserName">
          <el-input v-model="form.appraiseUserName" placeholder="请输入用户名" maxlength="30" />
        </el-form-item>
        <el-form-item label="综合评分" prop="appraiseScore">
          <el-rate v-model="form.appraiseScore" :max="5" show-score />
        </el-form-item>
        <el-form-item label="物流评分" prop="logisticsScore">
          <el-rate v-model="form.logisticsScore" :max="5" show-score />
        </el-form-item>
        <el-form-item label="服务评分" prop="serviceScore">
          <el-rate v-model="form.serviceScore" :max="5" show-score />
        </el-form-item>
        <el-form-item label="评论内容" prop="context">
          <el-input
            v-model="form.context"
            type="textarea"
            :rows="4"
            placeholder="请输入评论内容"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="评论图片">
          <upload-image-url
            ref="appraiseImageUpload"
            :image-count="4"
            @notifyUploadCoverImage="handleAppraiseImageUpload"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="_submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryShopAppraise,
  saveShopAppraise,
  updateShopAppraise,
  deleteShopAppraise
} from '@/api/goods/shopAppraiseManage/shopAppraiseManageApi'
import { getDict, getShopId } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'ShopAppraiseManage',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      isEdit: false,
      submitLoading: false,
      shopAppraiseManageInfo: {
        appraises: [],
        total: 0,
        records: 1,
        appraiseScores: [],
        conditions: {
          prodName: '',
          appraiseScore: '',
          appraiseUserName: '',
          shopId: '',
          objType: '1001',
          page: 1,
          row: 10
        }
      },
      form: {
        appraiseId: '',
        shopId: '',
        objId: '',
        objType: '1001',
        appraiseUserName: '',
        appraiseUserId: '-1',
        appraiseScore: 5,
        logisticsScore: 5,
        serviceScore: 5,
        context: '',
        imgPath: '',
        parentAppraiseId: '-1'
      },
      rules: {
        objId: [{ required: true, message: '请输入商品ID', trigger: 'blur' }],
        appraiseUserName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        appraiseScore: [{ required: true, message: '请选择综合评分', trigger: 'change' }],
        context: [{ required: true, message: '请输入评论内容', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑评论' : '新增评论'
    }
  },
  created() {
    this.shopAppraiseManageInfo.conditions.shopId = getShopId()
    this._listShopAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    this.getDictData()
  },
  methods: {
    getImgList(imgPath) {
      if (!imgPath) {
        return []
      }
      return String(imgPath).split('|').filter(item => !!item)
    },
    handleAppraiseImageUpload(urls) {
      this.form.imgPath = (urls || []).filter(item => !!item).join('|')
    },
    async getDictData() {
      try {
        const { data } = await getDict('s_shop_appraise', 'appraise_score')
        this.shopAppraiseManageInfo.appraiseScores = data || []
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listShopAppraises(_page, _rows) {
      this.currentPage = _page
      this.pageSize = _rows
      this.shopAppraiseManageInfo.conditions.page = _page
      this.shopAppraiseManageInfo.conditions.row = _rows
      const params = {
        ...this.shopAppraiseManageInfo.conditions,
        appraiseUserName: (this.shopAppraiseManageInfo.conditions.appraiseUserName || '').trim(),
        prodName: (this.shopAppraiseManageInfo.conditions.prodName || '').trim(),
        appraiseScore: (this.shopAppraiseManageInfo.conditions.appraiseScore || '').toString().trim()
      }

      try {
        const res = await queryShopAppraise(params)
        this.shopAppraiseManageInfo.total = res.total
        this.shopAppraiseManageInfo.records = res.records
        this.shopAppraiseManageInfo.appraises = res.data || []
        this.total = res.total || 0
      } catch (error) {
        console.error('请求失败处理', error)
        this.$message.error('查询评论失败')
      }
    },
    _queryOrdersMethod() {
      this._listShopAppraises(this.DEFAULT_PAGE, this.pageSize)
    },
    _resetOrdersMethod() {
      this.shopAppraiseManageInfo.conditions.prodName = ''
      this.shopAppraiseManageInfo.conditions.appraiseUserName = ''
      this.shopAppraiseManageInfo.conditions.appraiseScore = ''
      this._listShopAppraises(this.DEFAULT_PAGE, this.pageSize)
    },
    _openAddDialog() {
      this.isEdit = false
      this._resetForm()
      this.form.shopId = getShopId()
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.appraiseImageUpload) {
          this.$refs.appraiseImageUpload.clearImages()
        }
      })
    },
    _openEditDialog(row) {
      this.isEdit = true
      this.form = {
        appraiseId: row.appraiseId,
        shopId: row.shopId || getShopId(),
        objId: row.objId,
        objType: row.objType || '1001',
        appraiseUserName: row.appraiseUserName,
        appraiseUserId: row.appraiseUserId || '-1',
        appraiseScore: Number(row.appraiseScore) || 5,
        logisticsScore: Number(row.logisticsScore) || Number(row.appraiseScore) || 5,
        serviceScore: Number(row.serviceScore) || Number(row.appraiseScore) || 5,
        context: row.context || '',
        imgPath: row.imgPath || '',
        parentAppraiseId: row.parentAppraiseId || '-1'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.appraiseImageUpload) {
          const images = this.getImgList(row.imgPath)
          this.$refs.appraiseImageUpload.setImages(images)
        }
      })
    },
    _openDeleteDialog(row) {
      this.$confirm('确认删除该评论吗？删除后将不再计入店铺星级。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteShopAppraise({
            appraiseId: row.appraiseId,
            shopId: row.shopId || getShopId()
          })
          this.$message.success('删除成功')
          this._listShopAppraises(this.currentPage, this.pageSize)
        } catch (error) {
          this.$message.error(typeof error === 'string' ? error : '删除失败')
        }
      }).catch(() => {})
    },
    _resetForm() {
      this.form = {
        appraiseId: '',
        shopId: getShopId(),
        objId: '',
        objType: '1001',
        appraiseUserName: '',
        appraiseUserId: '-1',
        appraiseScore: 5,
        logisticsScore: 5,
        serviceScore: 5,
        context: '',
        imgPath: '',
        parentAppraiseId: '-1'
      }
      if (this.$refs.appraiseForm) {
        this.$refs.appraiseForm.clearValidate()
      }
      if (this.$refs.appraiseImageUpload) {
        this.$refs.appraiseImageUpload.clearImages()
      }
    },
    _submitForm() {
      this.$refs.appraiseForm.validate(async valid => {
        if (!valid) {
          return
        }
        if (!this.form.appraiseScore || this.form.appraiseScore < 1) {
          this.$message.warning('请选择综合评分')
          return
        }
        this.submitLoading = true
        const payload = {
          ...this.form,
          shopId: this.form.shopId || getShopId(),
          objId: (this.form.objId || '').trim(),
          appraiseScore: String(this.form.appraiseScore),
          logisticsScore: String(this.form.logisticsScore || this.form.appraiseScore),
          serviceScore: String(this.form.serviceScore || this.form.appraiseScore),
          imgPath: this.form.imgPath || ''
        }
        try {
          if (this.isEdit) {
            await updateShopAppraise(payload)
            this.$message.success('修改成功')
          } else {
            await saveShopAppraise(payload)
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          const stayPage = this.isEdit
          this._listShopAppraises(stayPage ? this.currentPage : this.DEFAULT_PAGE, this.pageSize)
        } catch (error) {
          this.$message.error(typeof error === 'string' ? error : (this.isEdit ? '修改失败' : '新增失败'))
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listShopAppraises(this.DEFAULT_PAGE, val)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listShopAppraises(val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>
